import type { JSX } from 'react';
import { OperatorBadge } from '../../tom/components/OperatorBadge.tsx';

export function UsbStickSyncStatus(props: { synced: boolean }): JSX.Element {
    return (
        <OperatorBadge circular empty color={props.synced ? 'green' : 'red'} />
    );
}
